// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DismissVisitModal-module__modalOverlay___PWEI6 {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.35);
}

.DismissVisitModal-module__modalCard___qSZBg {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.DismissVisitModal-module__modalHeader___gbZni {
  padding: 18px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}

.DismissVisitModal-module__modalTitle___EJgqU {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  color: #111827;
}

.DismissVisitModal-module__modalSubtitle___Shpqh {
  margin-top: 4px;
  font-size: 14px;
  line-height: 1.4;
  color: #6b7280;
}

.DismissVisitModal-module__modalBody___pghJq {
  padding: 16px 20px 18px;
}

.DismissVisitModal-module__sectionLabel___KJWT8 {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
}

.DismissVisitModal-module__reasonList___rkNzI {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 0 16px;
  padding: 0;
  border: 0;
}

.DismissVisitModal-module__reasonRow___Qs1U8 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
}

.DismissVisitModal-module__reasonRowActive___dPapL {
  border-color: #111827;
  background: #f9fafb;
  color: #111827;
}

.DismissVisitModal-module__dateLabel___FjXcH {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
}

.DismissVisitModal-module__dateLabel___FjXcH + .DismissVisitModal-module__dateLabel___FjXcH {
  margin-top: 14px;
}

.DismissVisitModal-module__noteInput___ZNRDB {
  display: block;
  box-sizing: border-box;
  width: 100%;
  margin-top: 6px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  resize: none;
}

.DismissVisitModal-module__dateInput____QK2T {
  display: block;
  box-sizing: border-box;
  width: 100%;
  margin-top: 6px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
}

.DismissVisitModal-module__modalFooter___io2Ie {
  border-top: 1px solid #e5e7eb;
  padding: 12px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.DismissVisitModal-module__modalSecondaryAction___tcVuf {
  min-width: 88px;
  padding: 8px 14px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  cursor: pointer;
}

.DismissVisitModal-module__modalPrimaryAction___BnZoN {
  min-width: 88px;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  background: #1f2937;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}

.DismissVisitModal-module__modalPrimaryAction___BnZoN:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/VisitsDueView/DismissVisitModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,+BAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.modalCard {\n  width: 100%;\n  max-width: 420px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n.modalHeader {\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modalTitle {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: #111827;\n}\n\n.modalSubtitle {\n  margin-top: 4px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #6b7280;\n}\n\n.modalBody {\n  padding: 16px 20px 18px;\n}\n\n.sectionLabel {\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #6b7280;\n}\n\n.reasonList {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0 0 16px;\n  padding: 0;\n  border: 0;\n}\n\n.reasonRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  cursor: pointer;\n}\n\n.reasonRowActive {\n  border-color: #111827;\n  background: #f9fafb;\n  color: #111827;\n}\n\n.dateLabel {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #6b7280;\n}\n\n.dateLabel + .dateLabel {\n  margin-top: 14px;\n}\n\n.noteInput {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 6px;\n  padding: 8px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #111827;\n  resize: none;\n}\n\n.dateInput {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 6px;\n  padding: 8px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #111827;\n}\n\n.modalFooter {\n  border-top: 1px solid #e5e7eb;\n  padding: 12px 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.modalSecondaryAction {\n  min-width: 88px;\n  padding: 8px 14px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n.modalPrimaryAction {\n  min-width: 88px;\n  padding: 8px 14px;\n  border: none;\n  border-radius: 6px;\n  background: #1f2937;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.modalPrimaryAction:disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `DismissVisitModal-module__modalOverlay___PWEI6`,
	"modalCard": `DismissVisitModal-module__modalCard___qSZBg`,
	"modalHeader": `DismissVisitModal-module__modalHeader___gbZni`,
	"modalTitle": `DismissVisitModal-module__modalTitle___EJgqU`,
	"modalSubtitle": `DismissVisitModal-module__modalSubtitle___Shpqh`,
	"modalBody": `DismissVisitModal-module__modalBody___pghJq`,
	"sectionLabel": `DismissVisitModal-module__sectionLabel___KJWT8`,
	"reasonList": `DismissVisitModal-module__reasonList___rkNzI`,
	"reasonRow": `DismissVisitModal-module__reasonRow___Qs1U8`,
	"reasonRowActive": `DismissVisitModal-module__reasonRowActive___dPapL`,
	"dateLabel": `DismissVisitModal-module__dateLabel___FjXcH`,
	"noteInput": `DismissVisitModal-module__noteInput___ZNRDB`,
	"dateInput": `DismissVisitModal-module__dateInput____QK2T`,
	"modalFooter": `DismissVisitModal-module__modalFooter___io2Ie`,
	"modalSecondaryAction": `DismissVisitModal-module__modalSecondaryAction___tcVuf`,
	"modalPrimaryAction": `DismissVisitModal-module__modalPrimaryAction___BnZoN`
};
module.exports = ___CSS_LOADER_EXPORT___;
